<template>
    <div class="page-wrap">
        <div class="content" ref="content">
            <div class="breadcrumb">版权（著作权）认证</div>
            <!-- <div class="steps-wrap">
                <TsaSteps :active="active" />
            </div> -->
            <div class="section">
                <div class="box box2">
                    <div class="title">创作过程认证</div>
                    <p class="title-bot">创作过程文件是证明作品权属的重要法律依据。为防止<b>创意被抄袭、作品被抢先发表、版权争议证据不足</b>，我们建议您自创意之初起，随时将重要草稿、修改记录、阶段性成果等过程文件进行<b>可信时间戳认证</b>，构建<b>完整、连续的创作证据链</b>。让每一个创作痕迹，都成为您坚实的法律底气！</p>
                    <div class="stage" :class="{'justOne': stageList[0].tipCode===tipCodeConfig}" v-if="stageList.length>0">
                        <div class="upload-input">
                            <input type="file" :accept="isIOS ? 'application/octet-stream':'*/*'" multiple="multiple" ref="inputer"  @change="addfile(1, '', form.category)" />
                        </div>
                        <div class="stage-item add-stage top-add-stage" v-if="stageList[0].tipCode===tipCodeConfig">
                            <div class="shaft">
                                <div class="arrow"></div>
                            </div>
                            <div class="add-stage-btn">
                                <span @click="addStageFront(-1)">新增阶段<i class="el-icon-plus"></i></span>
                            </div>
                        </div>
                        <div class="stage-item" v-for="(item,index) in stageList" :key="index" :ref="'stageIndex'+index">
                            <div class="shaft">
                                <div class="arrow" 
                                    :class="{'hasFile':item.dramaStageFileDraftList && item.dramaStageFileDraftList.length>0,'expand':!item.fold}" 
                                    @click="toggleExpand(item,index)"
                                >
                                    <i class="el-icon-arrow-up"></i>
                                </div>
                                <div class="add-arrow" v-if="item.id && index<stageList.length-1">
                                    <div class="arrow" @click="addStageFront(index)">
                                        <i class="el-icon-plus"></i>
                                    </div>
                                    <!-- <el-tooltip effect="dark" popper-class="myShadowTooltip" placement="top">
                                        <div slot="content" class="blue">在当前位置新增阶段</div>
                                        <div class="arrow" @click="addStageFront(index)">
                                            <i class="el-icon-plus"></i>
                                        </div>
                                    </el-tooltip> -->
                                </div>
                            </div>
                            <div class="stage-content" :ref="'stage'+item.tipCode">
                                <div class="stage-content-title">
                                    <div class="text" :class="{'text2':item.tipCode==tipCodeConfig}">
                                        <template v-if="!item.editStatus">
                                            <p><span :class="{'require':item.tipCode==tipCodeConfig}">阶段{{ index+1 }}：</span>{{ item.name }}</p>
                                        </template>
                                        <div class="edit-status" v-else>
                                            <div class="edit-input">
                                                <el-input maxlength="50" show-word-limit v-model="item.editName" @keyup.enter.native="saveStageName(index,item)"></el-input>
                                            </div>
                                        </div>
                                        <div class="tip" v-if="item.tipCode===tipCodeConfig" style="display:block;margin:0 10px">（必填）</div>
                                        <div class="tip" v-if="item.tipCode===tipCodeConfig && tipCodeError">
                                            {{ form.type==1 ?'请上传成片视频，完成认证':'请上传定稿成品，完成认证' }}
                                        </div>
                                    </div>
                                    <div class="operation" v-if="item.tipCode!==tipCodeConfig">
                                        <i class="el-icon-edit" @click="editStageName(index,item)"  v-if="!item.editStatus"></i>
                                        <template v-else>
                                            <span class="cancel" @click="cancelStageName(index,item)">取消</span>
                                            <span class="save" @click="saveStageName(index,item)">保存</span>
                                        </template>
                                        <i class="el-icon-delete" @click="deleteStage(index,item)"></i>
                                    </div>
                                </div>
                                <template v-if="!item.fold">
                                    <div class="stage-des" v-if="item.tipCode>0 && tipList[item.tipCode-1]">如：{{ tipList[item.tipCode-1].content }}等</div>
                                    <div 
                                        @dragenter="dragenter($event)"
                                        @dragover="dragover($event)"
                                        @dragleave="dragenter($event)"
                                        @drop="drop($event,index)"
                                    >
                                        <div class="addBtn" v-if="(!item.dramaStageFileDraftList || item.dramaStageFileDraftList.length===0) && item.id">
                                            <span @click="chooseFileOrFolder(index)"><i class="el-icon-plus"></i>点击添加</span>
                                        </div>  
                                        <template v-if="item.dramaStageFileDraftList && item.dramaStageFileDraftList.length>0">
                                            <div class="table">
                                                <TsaTable
                                                    :data="item.dramaStageFileDraftList"
                                                    stripe
                                                    style="width: 100%"
                                                    class="copyrightDetailTable"
                                                    ref="TsaTable"
                                                    customRowKey="id"
                                                >
                                                    <!-- <el-table-column
                                                        type=index
                                                        label="序号"
                                                        width="60"
                                                        align="center"
                                                    >
                                                    </el-table-column> -->
                                                    <el-table-column
                                                        prop="name"
                                                        min-width="150"
                                                        label="名称"
                                                        align="center"
                                                    >
                                                        <template slot-scope="scope">
                                                            <div class="cell-container" @click="lookDetail(scope.row)">
                                                                {{ scope.row.name }}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="storeType"
                                                        label="认证方式"
                                                        min-width="100"
                                                        align="center"
                                                    >
                                                        <template slot-scope="scope">
                                                            {{ scope.row.storeType==0? '保密认证':'存证认证' }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        prop="operatedAt"
                                                        label="认证时间"
                                                        align="center"
                                                        min-width="150"
                                                    >
                                                        <template slot-scope="scope">
                                                            <div class="cell-container">
                                                                {{ scope.row.operatedAt | timeFormat('YYYY-MM-DD HH:mm:ss')}}
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column
                                                        label="操作"
                                                        align="center"
                                                        width="130"
                                                    >
                                                        <template slot-scope="scope">
                                                            <div class="tableOpt">
                                                                <p class="btn" @click="lookDetail(scope.row)">详情</p>
                                                                <p class="btn" @click="deleteFile(scope.row,scope.$index,index,item)">删除</p>
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                </TsaTable>
                                            </div>
                                            <div class="uploadArea" @click="chooseFileOrFolder(index)">
                                                <i class="el-icon-plus"></i>
                                                <span>点击添加</span>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="stage-item add-stage">
                            <div class="shaft">
                                <div class="arrow"></div>
                            </div>
                            <div class="add-stage-btn">
                                <span @click="addStage">新增阶段<i class="el-icon-plus"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer second-footer">
            <span><TsaButton plain @click="prev">上一步</TsaButton></span>
            <span><TsaButton @click="next">下一步</TsaButton></span>
            <span><TsaButton @click="saveDraft" backGroundColor="linear-gradient( 90deg, #0047FF 0%, #2377FF 100%)">暂存草稿箱</TsaButton></span>
        </div>
        <el-dialog title="请选择文件来源" :visible.sync="fileOrFolder" width="95%" class="fileOrFolder" :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body="false">
            <div class="dialog_cnt">
                <div class="choose-btns">
                    <div class="btn" @click="chooseLocalFile">
                        <p>本地文件</p>
                    </div>
                    <div class="btn" @click="chhoseOnlineFile">
                        <p>已经可信时间戳认证的文件</p>
                        <!-- <span>已经可信时间戳认证的文件</span> -->
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 脱敏提示框 -->
        <van-dialog v-model="upTipDia" title="重要提示" class="mydialogBox" confirmButtonColor="#008AFF" confirmButtonText="知道了" @confirm="closeDia">
            <div class="dialog_cnt">
                <p class="tip" v-if="!isIOS">限于系统特性，若选择“<b>拍照或录像</b>”方式添加文件，在切换为“<b>保密认证</b>”时，该<b>原文件会丢失</b>，请选择其他方式添加文件。</p>
                <p class="tip" v-else>若希望认证相册中的影像，请先在相册将该影像保存至“文件”系统APP。</p>
                <p class="check-wrap"><van-checkbox v-model="upTipcCheck" @change="noDiaLog">不再弹出</van-checkbox></p>
            </div>
        </van-dialog>

        <van-popup v-model="confirmDialog" @close="close" position="bottom" round :lazy-render="false" closeable :get-container="getContainer" :style="{ maxHeight: '90%' }">
            <OpusApply :tableData="timeData" :form="form" :activeStage="activeStage" :stageList="stageList" @on-close="close" @addStageFile="addStageFile" @changeOpcity="changeOpcity" @showRules="showRules" v-if="confirmDialog" />
        </van-popup>

        <BillingRules ref="billingRules" />
        <TsaChooseOnlineFilesDialog ref="chooseOnlineFilesDialog"></TsaChooseOnlineFilesDialog>
    </div>
</template>

<script>
import TsaSteps from '@/components/copyright/basics/Steps'
import OpusApply from './components/OpusApply'
import {getStage,updateStage,addStage,addStageFront,deleteStage,getDramaDraft,addStageFile,deleteStageFile,updateDramaDraft} from '@/api/copyright/copyright'
import opusMixins from '@/mixins/opus/index'
import actionsMinix from '@/mixins/actions'
import {stageTipList,dramaStageTipList} from '@/config/copyright/stageTip'
import TsaChooseOnlineFilesDialog from './components/chooseOnlineFilesDialog.vue'
import BillingRules from '@/components/BillingRules.vue'
import { calculateMaxFilesOutOfRange } from '@/common/copyright/utils'
export default {
    data () {
        return {
            opusApplyHide:false,//固化弹窗的透明度是否为0
            tipCodeConfig:4,//配置第几阶段不能编辑删除
            active:2,
            tipList:[],
            tipCodeError:false,//必填的阶段是否显示非空提示
            activeStage:'',//当前上传的阶段
            stageList:[
                //     editStatus:false,//编辑状态
                //     editName:'',//编辑中的name
                //     fold:false,//该阶段是否折叠
            ],
            timeData:[],//当前选择的文件即将认证的list
            fileOrFolder:false,//选择文件还是文件夹的弹框
            confirmDialog:false,//认证确认框
            form:{},//第一步的值
            observer: null,//监听新增阶段是否在可视区域内
        }
    },
    components: {
        TsaSteps,
        OpusApply,
        TsaChooseOnlineFilesDialog,
        BillingRules
    },
    mixins: [ opusMixins, actionsMinix ],
    async created () {
        if(!this.$route.query.id){
            this.$router.replace({
                path:'/copyright/index',
                query:{
                    redirect:'false'
                }
            })
            return
        }
        try {
            let {code , data}=await getDramaDraft(this.$route.query.id)
            if(code===200){
                this.form=data;
                if(data.type==1){//短剧漫剧的标识
                    this.tipList=dramaStageTipList
                    this.tipCodeConfig=6
                }else{
                    this.tipList=(stageTipList.find((item) => {
                        return item.id == data.category
                    }).list)
                }
                this.init()
            }
        } catch (error) {
            console.log(error)
        }
        
    },
    computed: {
    },
    mounted () {
        // document.body.addEventListener('touchstart', function() {}, true);
        // // 处理滚动（相当于mouseleave）
        // document.querySelector('.content').addEventListener('scroll', this.scrollBlur, false);
    },
    beforeUnmount(){
        this.observerClose();
        //document.querySelector('.content').removeEventListener('scroll',this.scrollBlur);
    },
    methods: {
        getContainer() {
            return document.querySelector('.main');
        },
        closeDia(){
            this.choosefile();
        },
        // 选择本地文件
        chooseLocalFile () {
            this.upTipcCheck=this.$getlocalStorage('opusNoDia')
            if(!this.upTipcCheck){
                this.upTipDia=true
            }else{
                this.choosefile();
            }
        },
        // 线上文件选择
        chhoseOnlineFile () {
            this.fileOrFolder = false;
            let dramaStageFileDraftList = this.stageList[this.activeStage].dramaStageFileDraftList || []
            let ids = []
            dramaStageFileDraftList.forEach(item => {
                ids.push(item.dataId)
            })
            this.$refs.chooseOnlineFilesDialog.open({
                ids,
                alreadyCount: calculateMaxFilesOutOfRange(this.stageList, 'dramaStageFileDraftList'),
                onCancel: () => {

                },
                onConfirm: async (result) => {
                    this.$TsaProgress.show()
                    let failCount = 0
                    for (let i = 0; i < result.length; i++) {
                        const obj = result[i];
                        try {
                            await addStageFile({
                                localFileStatus: 0,
                                dramaId:this.$route.query.id,
                                dramaStageId:this.stageList[this.activeStage].id,
                                dataId:obj.id,
                                name:obj.name,
                                operatedAt:obj.tsaAt,
                            }, {
                                network400: 'custom400',
                                networkError: 'customError',
                            })
                        } catch (error) {
                            console.error(error)
                            failCount += 1
                        }
                        let percentage = parseInt(((i+1)/result.length)*100)
                        this.$TsaProgress.update(percentage)
                    }
                    setTimeout(() => {
                        this.$TsaProgress.hide()
                        if (failCount > 0) {
                            this.$TsaToastV2.show({
                                message: `已成功加载${result.length-failCount}条，失败${failCount}条`,
                                type: 'error',
                            })
                        }
                        // 执行与固化弹窗相同的关闭逻辑
                        this.close()
                        this.$refs.chooseOnlineFilesDialog.hide()
                    }, 500);
                }
            })
        },
        //监听新增的阶段是否在可视区域内监听的开启和关闭
        observerClose(){
            if (this.observer) {
                this.observer.disconnect();
                this.observer=null;
            }
        },
        observerOpen(container,target){
            let that=this;
            this.observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        console.log('在可视区域');
                        that.observerClose();
                    } else {
                        console.log('不在可视区域');
                        if(target){
                            target.scrollIntoView(false)
                            that.observerClose();
                        }
                    }
                });
            }, {
                root: container,// 指定容器
                rootMargin: '0px',
                threshold: 1,// 交叉比例达到100%时触发回调
            });
            this.observer.observe(target);
        },
        async init(text){
            try {
                let {data,code}=await getStage(this.$route.query.id)
                if(code!==200){
                    this.$router.replace({
                        path: '/copyright/index',
                        query:{
                            redirect:'false'
                        }
                    })
                    return
                }
                if(text=='merge'){
                    let mergedArr = data.map(item1 => {
                        const item2 = this.stageList.find(item2 => item2.id === item1.id);
                        return item2 ? { ...item2, ...item1 } : item1;
                    });
                    this.stageList=mergedArr;
                    //如果之前触发了tipCode6的错误提示，在此检测一次是否去掉
                    let obj = this.stageList.find(item => item.tipCode===this.tipCodeConfig)
                    if(!obj) return;
                    if(obj.dramaStageFileDraftList && obj.dramaStageFileDraftList.length>0){
                        this.tipCodeError=false;
                    }
                }else{
                    this.stageList=data;
                }
            } catch (error) {
                console.log(error)
            }
        },
        editStageName(index, item){
            let obj={
                ...this.stageList[index],
                editStatus:true,
                editName:item.name
            }
            this.$set(this.stageList, index, obj)
        },
        cancelStageName(index, item){
            if(!item.id){
                this.stageList.splice(index, 1)
            }else{
                let obj={
                ...this.stageList[index],
                    editStatus:false,
                    editName:''
                }
                this.$set(this.stageList, index, obj)
            }
        },
        async saveStageName(index,item){
            if (item.editName.length == 0 || item.editName.replace(/\s*/g, "").length == 0) {
                this.$toast('请输入阶段名称')
                return false;
            }
            if(item.editName!==item.name){
                item.tipCode=0;
                item.name=item.editName
            }
            try {
                if(item.id || item.id===0){
                    let {code}=await updateStage(item)
                    if(code===200){
                        item.editStatus=false;   
                        this.$set(this.stageList, index, item)
                        this.$toast('保存成功')
                        UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                            '操作类型': '编辑阶段成功'
                        })
                    }
                }else{
                    if(index==this.stageList.length-1){//最后面添加
                        item.ranking=this.stageList[index-1].ranking+1
                        let {data,code}=await addStage(item)
                        if(code===200){
                            this.$set(this.stageList, index, data)
                            this.$toast('阶段新增成功')
                            UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                                '操作类型': '阶段新增成功'
                            })
                        }
                    }else{
                        item.ranking=this.stageList[index+1].ranking
                        item.stageId=this.stageList[index+1].id
                        let {data,code}=await addStageFront(item)
                        if(code===200){
                            let mergedArr = data.map(item1 => {
                                const item2 = this.stageList.find(item2 => item2.id === item1.id);
                                return item2 ? { ...item2, ...item1 } : item1;
                            });
                            this.stageList=mergedArr;
                            this.$toast('阶段新增成功')
                            UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                                '操作类型': '阶段新增成功'
                            })
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        deleteStage(index,item){
            if(!item.id){
                this.stageList.splice(index, 1)
            }else{
                this.$TsaConfirmV2.show({
                    type:'warn',
                    title:'确认删除？',
                    message:`删除后该阶段的全部文件将会被删除，确定删除该阶段么？`,
                    confirmButtonText: '确认删除',
                    onConfirm:async ($vm) => {
                        $vm.loading = true
                        try {
                            let {code}=await deleteStage(item)
                            if(code===200){
                                UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                                    '操作类型': '删除阶段成功'
                                })
                                this.$toast('阶段删除成功')
                                this.stageList.splice(index, 1)
                                this.$TsaConfirmV2.hide()
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                })
            }
        },
        //添加阶段
        addStage(){
            const targetIndex = this.stageList.findIndex(item => item.id === '');
            if(targetIndex === -1){
                this.stageList.push({
                    id: '',
                    dramaDraftId:this.$route.query.id,
                    name: '',
                    tipCode: 0,
                    editStatus:true,//编辑状态
                    editName:'',//编辑中的name
                    fold:false,//该阶段是否展开
                })
                UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                    '操作类型': '新增阶段'
                })
            }else{
                this.$message.warning('请先保存已经新增的阶段')
            }
        },
        addStageFront(index){
            const targetIndex = this.stageList.findIndex(item => item.id === '');
            if(targetIndex === -1){
                this.stageList.splice(index+1, 0,{
                    id: '',
                    dramaDraftId:this.$route.query.id,
                    name: '',
                    tipCode: 0,
                    editStatus:true,//编辑状态
                    editName:'',//编辑中的name
                    fold:false,//该阶段是否展开
                })
                UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                    '操作类型': '新增阶段'
                })
                this.$nextTick(()=>{
                    this.observerOpen(document.querySelector('.content'),this.$refs['stageIndex'+(index+1)][0])
                })
            }else{
                this.$message.warning('请先保存已经新增的阶段')
            }
        },
        //点击上传按钮
        chooseFileOrFolder(n){
            if (calculateMaxFilesOutOfRange(this.stageList, 'dramaStageFileDraftList') >= 1000) {
                this.$TsaToastV2.show({
                    message: '最多支持添加1000个文件',
                    type: 'warn'
                })
                return
            }
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                '操作类型': '创作过程_点击上传'
            })
            //初始化将要申请的文件list
            this.$refs.inputer.value= null;
            this.activeStage=n;
            this.timeData=[];
            this.fileOrFolder=true;
        },
        //拖拽功能
        async drop(event,index){
            event.preventDefault();
            event.stopPropagation();
            const filePromises = []
            const items = event.dataTransfer.items
            if(items == undefined){
                this.$message.error('当前浏览器不支持拖拽功能，请更换谷歌，火狐等高级浏览器后再使用该功能。')
                return
            }
            this.$TsaLoadingV2.show()
            this.$refs.inputer.value= null;
            this.activeStage=index;
            this.timeData=[];
            // 遍历所有拖拽的项目
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                if (item.kind === 'file') {
                    const entry = item.webkitGetAsEntry()
                    if (entry) {
                        // 创建Promise并添加到数组
                        const promise =this.processEntry(entry, this.form.category)
                        filePromises.push(promise)
                    }
                }
            }
            Promise.all(filePromises).then((objList) => {
                console.log('文件读取完成')
                this.$TsaLoadingV2.hide()
                this.confirmDialog=true;
            }).catch((error) => {
                console.error('处理文件时出错:', error)
                this.$TsaLoadingV2.hide()
                if(error.code===1000){
                    this.$TsaToastV2.show({
                        message: '最多支持添加1000个文件',
                        type: 'warn'
                    })
                }else{
                    this.$TsaToastV2.show({
                        message: '文件读取失败',
                        type: 'warn'
                    })
                }
            })    
        },
        //关闭确认弹框
        close(e){
            this.timeData=[];
            this.confirmDialog=false;
            this.opusApplyHide=false;
            this.init('merge');
            if(e && e.opusFileUploadSuccessNumber>0){
                this.$TsaToastV2.show({
                    type: 'success',
                    message: `${e.opusFileUploadSuccessNumber}个文件认证成功，已成功添加到「${this.stageList[this.activeStage].name}」`
                })
            }
        },
        //切换展开关闭
        toggleExpand(item,index){
            item.fold=!item.fold;  
            this.$set(this.stageList, index, item)
        },
        async addStageFile(obj){
            try {
                await addStageFile({
                    dramaId:this.$route.query.id,
                    dramaStageId:this.stageList[this.activeStage].id,
                    dataId:obj.id,
                    name:obj.opusName,
                    operatedAt:obj.operatedAt,
                    fileType:obj.fileType
                })
            } catch (error) {
                console.log(error)
            }
        },
        deleteFile(row,index,pIndex,item){
            this.$TsaConfirmV2.show({
                type:'warn',
                title:'确认删除？',
                message:`确定将该文件从「${item.name}」中删除么？`,
                confirmButtonText: '确认删除',
                onConfirm:async ($vm) => {
                    $vm.loading = true
                    try {
                        let {code}=await deleteStageFile({ids:[row.id],dramaDraftId:this.$route.query.id})
                        if(code===200){
                            UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                                '操作类型': '删除证据成功'
                            })
                            this.$toast('删除成功')
                            this.stageList[pIndex].dramaStageFileDraftList.splice(index, 1)
                            this.$TsaConfirmV2.hide()
                        }
                    } catch (error) {
                        console.log(error)
                    }
                }
            })
        },
        lookDetail(row){
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                '操作类型': '查看证据详情'
            })
            this.gotoDetailCommon({ row }, 'copyrightSecond')
        },
        saveDraft(){
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                '操作类型': '暂存草稿箱'
            })
            this.$TsaConfirmV2.show({
                title: '暂存草稿箱',
                message: '您填写的信息已保存至作品草稿箱，可随时在草稿箱中继续完成认证。',
                type: 'success',
                cancelButtonText: '认证新作品',
                confirmButtonText: '进入草稿箱',
                onCancel: () => {
                    this.$TsaConfirmV2.hide()
                    UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                        '操作类型': '认证新作品'
                    },()=>{
                        this.$router.push({
                            path: '/copyright/index',
                            query:{
                                redirect:'false'
                            }
                        })
                    })
                },
                onConfirm: () => {
                    this.$TsaConfirmV2.hide()
                    UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                        '操作类型': '进入草稿箱'
                    },()=>{
                        this.$router.push({
                            path: '/copyright/myDraft'
                        })
                    })
                },
            })
        },
        prev(){
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                '操作类型': '上一步'
            },()=>{
                this.$router.replace({
                    path:this.form.type==1?'/copyright/drama':'/copyright/index',
                    query:{
                        id:this.$route.query.id,
                        redirect:'false'
                    }
                })
            })
        },
        async next(){
            let obj = this.stageList.find(item => item.tipCode===this.tipCodeConfig)
            if(!obj.dramaStageFileDraftList || obj.dramaStageFileDraftList.length===0){
                this.tipCodeError=true;
                this.$nextTick(()=>{
                    if(this.$refs['stage'+this.tipCodeConfig]){
                        this.$refs['stage'+this.tipCodeConfig][0].scrollIntoView({
                            behavior: 'smooth'
                        })
                    }
                })
                return
            }
            await this.getUserInfo();
            await updateDramaDraft(this.form)
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                '操作类型': '下一步'
            },()=>{
                this.$router.replace({
                    path:'/copyright/copyrightThird',
                    query:{
                        id:this.$route.query.id
                    }
                })
            })
            
        },
        changeOpcity(bool){
            this.opusApplyHide=bool
        },
        showRules(){
            this.$refs.billingRules.open()
        }
    }
}
</script>
<style src="@/assets/css/copyright/index.scss" scoped lang="scss"></style>
